import ImageWithBasePath from "@/components/image-with-base-path"

const ChooseSection = () => {
  return (
    <>
  {/* Choose Section */}
  <section className="offer-section-fourteen section">
    <div className="container">
      <div className="offer-sec">
        <div className="row g-4 align-items-center">
          <div className="col-lg-5 col-xl-6">
            <h2>Ready Discover More? Contact Us Today!</h2>
          </div>
          <div className="col-lg-7 col-xl-6">
            <div className="offer-wrap">
              <div className="offer-info">
                <div className="offer-icon">
                  <i className="isax isax-messages-3" />
                </div>
                <div>
                  <p className="title">Email Inquiries</p>
                  <p className="fw-semibold mb-0">info@example.com</p>
                </div>
              </div>
              <div className="offer-info">
                <div className="offer-icon">
                  <i className="isax isax-call-calling" />
                </div>
                <div>
                  <p className="title">For Booking Call</p>
                  <p className="fw-semibold mb-0">+1 24565 89856</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ImageWithBasePath
          src="assets/img/bg/offer-bg.png"
          alt="bg"
          className="offer-bg img-fluid"
        />
      </div>
      <div className="row">
        <div className="col-xl-5">
          <div
            className="section-header section-header-fourteen wow fadeInUp"
            data-wow-duration="1s"
          >
            <h2 className="section-title">
              Why <span className="section-line">Choose</span>{" "}
              <span className="subtitle">Our Clinic</span>
            </h2>
          </div>
        </div>
        <div className="col-xl-7">
          <div className="row g-4">
            <div className="col-md-6 d-flex">
              <div className="offer-item rotate-1 flex-fill">
                <div className="offer-icon">
                  <ImageWithBasePath
                    src="assets/img/icons/offer-01.svg"
                    alt="icon"
                    className="img-fluid"
                  />
                </div>
                <h3 className="custom-title mb-2">
                  Personalized Skin Care Solutions
                </h3>
                <p className="mb-0">
                  Every skin is different. We create customized treatment plans
                  based on your unique needs.
                </p>
              </div>
            </div>
            <div className="col-md-6 d-flex">
              <div className="offer-item rotate-n1 flex-fill">
                <div className="offer-icon">
                  <ImageWithBasePath
                    src="assets/img/icons/offer-02.svg"
                    alt="icon"
                    className="img-fluid"
                  />
                </div>
                <h3 className="custom-title mb-2">
                  Advanced Technology &amp; Treatments
                </h3>
                <p className="mb-0">
                  We use modern equipment and the latest dermatology techniques
                  for safe and reliable results.
                </p>
              </div>
            </div>
            <div className="col-md-6 d-flex">
              <div className="offer-item rotate-n1 flex-fill">
                <div className="offer-icon">
                  <ImageWithBasePath
                    src="assets/img/icons/offer-03.svg"
                    alt="icon"
                    className="img-fluid"
                  />
                </div>
                <h3 className="custom-title mb-2">
                  Comprehensive Skin Care Services
                </h3>
                <p className="mb-0">
                  From medical dermatology to cosmetic treatments, we offer
                  complete skin care under one roof.
                </p>
              </div>
            </div>
            <div className="col-md-6 d-flex">
              <div className="offer-item rotate-1 flex-fill">
                <div className="offer-icon">
                  <ImageWithBasePath
                    src="assets/img/icons/offer-04.svg"
                    alt="icon"
                    className="img-fluid"
                  />
                </div>
                <h3 className="custom-title mb-2">
                  Safe &amp; Comfortable Environment
                </h3>
                <p className="mb-0">
                  We ensure hygienic facilities, patient comfort, and a relaxing
                  consultation experience.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  {/* Choose Section End */}
</>

  )
}

export default ChooseSection